import PartnerName from './partner_name';

export default PartnerName;
